class DownloadFileLink {
  static getURLOrigin = () => {
    const { origin } = window.location;
    const { NODE_ENV, REACT_APP_RAILS_HOST } = process.env;

    return (NODE_ENV === 'development' && REACT_APP_RAILS_HOST) ? REACT_APP_RAILS_HOST : origin;
  };

  static createLink = (pageId) => {
    const originURL = DownloadFileLink.getURLOrigin();

    return `${originURL}/api/v1/maps/${pageId}.csv`;
  };
}

export default DownloadFileLink;
